import Copy from "./Copy";

export default {
    button: Copy,
    name: "Copy",
};
